<template>
  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Convivência Familiar e Comunitária</b></h5>
      </th>
    </tr>
    <tr>
      <td>
        HÁ QUANTOS ANOS A FAMÍLIA MORA NESTE ESTADO?
        <b>{{ item.convivencia.qtd_mora_estado }}</b>
      </td>
      <td>
        HÁ QUANTOS ANOS A FAMÍLIA MORA NO MUNICÍPIO?
        <b>{{ item.convivencia.qtd_mora_municipio }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        HÁ QUANTOS ANOS A FAMÍLIA MORA NO BAIRRO ATUAL?
        <b>{{ item.convivencia.qtd_mora_bairro }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        A FAMÍLIA, OU ALGUM DE SEUS MEMBROS, É VÍTIMA DE AMEAÇAS OU DE DISCRIMINAÇÃO NA COMUNIDADE ONDE RESIDE?
        <b v-if="item.convivencia.discriminacao_convivencia">
          {{ formatResultArray(item.convivencia.discriminacao_convivencia, $root.arrays.pergunta) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        A FAMÍLIA POSSUI PARENTES QUE RESIDAM PRÓXIMO AO SEU LOCAL DE MORADIA E QUE CONSTITUAM REDE DE APOIO E
        SOLIDARIEDADE?
        <b v-if="item.convivencia.apoio_parentes">
          {{ formatResultArray(item.convivencia.apoio_parentes, $root.arrays.pergunta) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        A FAMÍLIA POSSUI VIZINHOS QUE CONSTITUAM REDE DE APOIO E SOLIDARIEDADE?
        <b v-if="item.convivencia.apoio_vizinhos">
          {{ formatResultArray(item.convivencia.apoio_vizinhos, $root.arrays.pergunta) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        A FAMÍLIA, OU ALGUM DE SEUS MEMBROS, PARTICIPA DE GRUPOS RELIGIOSOS, COMUNITÁRIOS OU OUTROS GRUPOS/INSTITUIÇÕES
        QUE CONSTITUAM REDE DE APOIO E SOLIDARIEDADE?
        <b v-if="item.convivencia.apoio_grupo_comunitario">
          {{ formatResultArray(item.convivencia.apoio_grupo_comunitario, $root.arrays.pergunta) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        A FAMÍLIA, OU ALGUM DE SEUS MEMBROS, PARTICIPA DE MOVIMENTOS SOCIAIS, SINDICATOS, ORGANIZAÇÕES COMUNITÁRIAS,
        CONSELHOS OU QUAISQUER OUTRAS AÇÕES OU INSTITUIÇÕES VOLTADAS PARA ORGANIZAÇÃO POLÍTICA E DEFESA DE INTERESSES
        COLETIVOS?
        <b v-if="item.convivencia.grupos_sociais_defesa">
          {{ formatResultArray(item.convivencia.grupos_sociais_defesa, $root.arrays.pergunta) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        EXISTE ALGUMA CRIANÇA OU ADOLESCENTE DO GRUPO FAMILIAR QUE NÃO TEM ACESSO A ATIVIDADES DE LAZER, RECREAÇÃO E
        CONVÍVIO SOCIAL?
        <b v-if="item.convivencia.cri_ado_acesso_lazer">
          {{ formatResultArray(item.convivencia.cri_ado_acesso_lazer, $root.arrays.pergunta_cri_ado_acesso_lazer) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        EXISTE ALGUMA PESSOA IDOSA DO GRUPO FAMILIAR QUE NÃO TEM ACESSO A ATIVIDADES DE LAZER, RECREAÇÃO E CONVÍVIO
        SOCIAL?
        <b v-if="item.convivencia.idoso_acesso_lazer">
          {{ formatResultArray(item.convivencia.idoso_acesso_lazer, $root.arrays.pergunta) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        HÁ PESSOAS DEPENDENTES (CRIANÇAS, PESSOAS IDOSAS DEPENDENTES OU PESSOAS COM DEFICIÊNCIA) QUE PERMANECEM PERÍODOS
        DO DIA EM CASA SEM A COMPANHIA DE UM ADULTO?
        <b v-if="item.convivencia.dependente_cuidados">
          {{ formatResultArray(item.convivencia.dependente_cuidados, $root.arrays.pergunta_dependente_cuidados) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        PERCEPÇÃO/AVALIAÇÃO DO TÉCNICO SOBRE AS RELAÇÕES CONJUGAIS NA FAMÍLIA, SE FOR O CASO
        <b v-if="item.convivencia.relacoes_conjugais">
          {{ formatResultArray(item.convivencia.relacoes_conjugais, $root.arrays.relacoes_conjugais_familia) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        PERCEPÇÃO/AVALIAÇÃO DO TÉCNICO SOBRE AS RELAÇÕES ENTRE PAIS/RESPONSÁVEIS E OS FILHOS INCLUSIVE ENTRE O PADRASTO
        OU MADRASTA COM O(S) ENTEADOS(AS), SE FOR O CASO
        <b v-if="item.convivencia.relacoes_responsaveis">
          {{ formatResultArray(item.convivencia.relacoes_responsaveis, $root.arrays.relacoes_conjugais_familia) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        PERCEPÇÃO/AVALIAÇÃO DO TÉCNICO SOBRE AS RELAÇÕES ENTRE OS IRMÃOS, SE FOR O CASO
        <b v-if="item.convivencia.relacoes_entre_irmaos">
          {{ formatResultArray(item.convivencia.relacoes_entre_irmaos, $root.arrays.relacoes_conjugais_familia) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        PERCEPÇÃO/AVALIAÇÃO DO TÉCNICO SOBRE AS RELAÇÕES ENTRE OS IRMÃOS, SE FOR O CASO
        <b v-if="item.convivencia.relacoes_entre_irmaos">
          {{ formatResultArray(item.convivencia.relacoes_entre_irmaos, $root.arrays.relacoes_conjugais_familia) }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        INDIQUE SE HÁ RELAÇÕES CONFLITUOSAS ENVOLVENDO OUTROS INDIVÍDUOS QUE RESIDAM NO DOMICÍLIO?
        <b v-if="item.convivencia.relacoes_conflituosas_outros">
          {{
            formatResultArray(item.convivencia.relacoes_conflituosas_outros, $root.arrays.relacoes_conflituosas_outros)
          }}
        </b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        OUTRAS OBSERVAÇÕES REFERENTES AO DIAGNÓSTICO DAS CONDIÇÕES DE CONVIVÊNCIA FAMILIAR E COMUNITÁRIA
        <b>
          {{
            item.convivencia.observavoes_comunitaria
          }}
        </b>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
  methods: {
    formatResultArray(campo, array) {
      if (campo !== "" || campo != null) {
        const result = array.filter((e) => e.id === campo);
        if (result.length) {
          return result[0]["value"];
        }
      }
    },
  },
};
</script>

<style lang="scss"
       scoped></style>
